// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".css__version_dialog___1j7bo [class*=\"dialogBody\"] {\n    width: 30ch;\n    max-width: 50%;\n    top: 50%;\n    transform: translateY(-50%);\n}", ""]);
// Exports
exports.locals = {
	"version_dialog": "css__version_dialog___1j7bo"
};
module.exports = exports;
